<template>
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-eOJMYsd53ii+scO/bJGFsiCZc+5NDVN2yr8+0RDqr0Ql0h+rP48ckxlpbzKgwra6" crossorigin="anonymous">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css">
   <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"/>
  <!--<div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> |
    <router-link to="/p1">P1</router-link>
  </div>-->
  <router-view/>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;500;700&display=swap');

/** Generated by FG **/
@font-face {
	font-family: 'RoundedBT';
	src: url('assets/fonts/VAG Rounded BT.eot');
	src: local('☺'), url('assets/fonts/VAG Rounded BT.woff') format('woff'), url('assets/fonts/VAG Rounded BT.ttf') format('truetype'), url('assets/fonts/VAG Rounded BT.svg') format('svg');
	font-weight: normal;
	font-style: normal;
}
/** Generated by FG **/
@font-face {
	font-family: 'VAGRoundednormal';
	src: url('assets/fonts/VAGRounded Lt Normal.eot');
	src: local('☺'), url('assets/fonts/VAGRounded Lt Normal.woff') format('woff'), url('assets/fonts/VAGRounded Lt Normal.ttf') format('truetype'), url('assets/fonts/VAGRounded Lt Normal.svg') format('svg');
	font-weight: normal;
	font-style: normal;
}
#backhome{
    width: 230px;
    display: block;
    margin: auto;
    margin-top: 50px !important;
}
.logoepm{
    width: 165px;
    margin-top: 50px;

}
.padre {
  background: #fff;
  /*IMPORTANTE*/
  display: flex;
  justify-content: center;
  align-items: center;
}
.active{
  background-color: red !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
:root {
  --animate-delay: 0.5s !important;
}
.contadorcont{
  margin-top: 100px;
}
.contador{
    background: #007c32;
    padding: 2px 10px;
    border-radius: 21px;
    text-decoration: none;
    border: 3px solid #fff;
    position: relative;
    color: #fff;
    margin: auto;
    display: block;
    width: 170px;
    font-size: 22px;
    font-weight: 700;
    font-family: VAGRoundednormal,sans-serif;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
h4{
    font-size: 22px;
    width: 474px;
    color: #fff;
    text-align: center;
    margin: auto;
    margin-bottom: 7px;
    font-family: 'VAGRoundednormal', sans-serif;
    font-weight: 600 !important;
}
.fondo{
  max-width: 1170px;
  margin: auto;
}
.bg {
  width: 100%;
}
.bgcel{
  display: none;
}
.buprin{
    background: #007c32;
    padding: 2px 10px;
    border-radius: 21px;
    color: #fff;
    text-decoration: none;
    border: 3px solid #fff;
    position: relative;
    margin: auto;
    display: block;
    width: 170px;
    font-size: 22px;
    font-weight: 700;
    font-family: 'VAGRoundednormal', sans-serif;
}
.buprin:hover{
   color: #fff;
}
.contbut{
    width: 1170px;
    margin: auto;
    margin-top: -141px;
}
.contbut i{
  font-size: 28px;
}
.buinicio{
  margin-top: -297px;
}
.buintro{
  margin: 0px 0px 0px 201px;
}
.buintentar{
    margin-top: 71px;
    margin-right: 232px;    
}
.denuevo{
    margin-top: -118px;
    float: right;
    margin-right: 159px;
}
.contpre{
  margin-top: -205px;
}
.contpre a.butonpregun{
  background-color: #fff;
    margin: 4px 5px;
    display: inline-block;
    vertical-align: text-top;
    padding: 2px 11px 2px 0px;
    font-size: 15px;
    border-radius: 12px;
    font-family: 'VAGRoundednormal', sans-serif;
    font-weight: 600;
    color: #003b8f !important;

}
.butonres{
  display: inline-block;
  vertical-align: top;
}
.contpre span{
    background-color: #003b8f;
    border-radius: 10px;
    padding: 1px 6px;
    color: #fff;
    margin-right: 9px;
}
.contpre .divpre1{
  float: right;
  position: relative;
  margin-right: 29px;
}
.divpre3{
  width: 100% !important;
}
.pregunta3 h4 {
    text-align: center;
    width: 500px;
    float: right;
    margin-right: 223px;
    margin-top: 29px;
    right: 0px;
}
.pregunta3 a{
    margin: 6px 5px !important;
}
.pregunta1 .boton1{
    width: 344px;
}
.pregunta1 .boton2{
    width: 127px;
}
.pregunta1 .boton3 a{
  width: 415px;
  margin: auto;

}
.pregunta2 a{
    margin: 5px 5px;
}
.pregunta2 h4{
    color: #003b8f;
    font-family: 'VAGRoundednormal', sans-serif;
    font-weight: 800;
}
.pregunta4{
  margin-top: 40px;
}
.pregunta4 h4{
  color: #002778;
  width: 517px;
}
.pregunta4 .respuestas {
    width: 882px !important;
    margin: auto;
}
.pregunta5 {
    margin-top: 40px;
}
.pregunta5 a,.pregunta4 a{
  margin: 6px 5px;
}
.pregunta5 h4 {
    color: #002778;
    width: 578px;
    margin-right: 229px;
}
.pregunta5 .respuestas {
    width: 882px !important;
    margin: auto;
}
.pregunta6 a {
    margin: 6px 5px;
}
@media screen and (max-width: 1400px){
    .denuevo {
      margin-top: -90px;
      margin-right: 321px;
    }
    .buintentar{
      margin-top: 85px;
      margin-right: 279px;  
  }
  .ajax-loader-container {
      width: 670px !important;
      margin-top: 183px !important;
  }
}
@media screen and (max-width: 1301px){
  .pregunta5 h4{
        margin-right: 118px;
  }
}
@media screen and (max-width: 1295px){
  .pregunta5 h4 {
    margin-right: 150px;
  }
  .pregunta6 {
    margin-top: 40px;
  }
}
@media screen and (max-width: 1200px){
  .pregunta3 h4{
    margin-right: 131px;
  }
  .denuevo {
    margin-top: -49px;
    margin-right: 396px;
  } 
  .ajax-loader-container {
    width: 583px !important;
    margin-top: 139px !important;
  }
  .buintentar{
    margin-right: 374px;
  }
}
@media screen and (max-width: 1198px){
  .pregunta3 h4 {
    margin-right: 43px;
  }
  .pregunta5 h4 {
    margin-right: 29px;
  }
}
@media screen and (max-width: 992px){
  .bg{
    display: none;
  } 
  .bgcel{
    display: block;
    width: 100%;
    border-radius: 20px;
    padding: 5px;
  }
  .contbut{
      margin-top: -535px;
  }
  .denuevo{
       width: 200px;
    font-size: 33px;
    float: initial;
    margin: auto;
  }
  .buinicio {
    width: 200px;
    margin-top: 0px;
    font-size: 33px;
  }
  .contbut{
    width: 100%;
  }
  .buintro{
    margin-top: -400px;
    margin: auto !important;
    
  }
  .contpre {
    margin-top: -700px;
    max-width: 100% !important;
  }
  .contpre h4{
    width: 100%;
    color: #00459f;
    text-align: center;
    margin: auto;
    font-family: 'VAGRoundednormal', sans-serif;
    font-weight: 600 !important;
  }
  .contpre a.butonpregun:hover{
      background-color:#6b9503;
  }
  .pregunta1 .boton1{
    width: 100%;
  }
  .pregunta1 .boton2 {
    width: 100%;
  }
  .contpre .divpre1{
    float: none;
  }
  .pregunta1 .boton3 a{
    width: 100%;
  }
  .contpre .divpre1{
    margin-right: 0px;
  }
  .fondo {
    width: 100% !important;
    max-width: 100% !important;
    margin: auto;
    padding-right: 0px !important;
    padding-left: 0px !important;
    margin: 0px;
  }
  .pregunta3 h4 {
    color: #fff;
  }
  .pregunta5 .respuestas,.pregunta4 .respuestas{
    width: 58.3333333333% !important;
  }
  .ajax-loader-container{
    margin-top: 339px !important;
  }
  .contbut{
    margin-top: 0px;
  }
  .buintentar{
    margin-top: 0px;
  }
}
@media screen and (max-width: 850px){
  .contpre {
    margin-top: -635px;
  }
  .buintentar{
    margin-right: 152px;
  }
}
@media screen and (max-width: 772px){
  .contpre {
      margin-top: -577px;
  }
}
@media screen and (max-width: 767px){
  .pregunta5 .respuestas,.pregunta4 .respuestas{
        width: 50% !important;
  }
  
}
@media screen and (max-width: 650px){
  .contbut{
      margin-top: -359px;
  }
  .denuevo,.buintro, .buinicio {
    width: 175px;
    font-size: 25px;
  }
  .buintentar{
      margin-top: 316px;
  }
  .ajax-loader-container{
    width: 100% !important;
  }
  .contpre {
    margin-top: -515px;
  }
  .contpre h4{
    margin-top: 36px;
    font-size: 19px;
  }
  .contpre a.butonpregun{
      padding: 2px 5px 2px 0px;
      font-size: 12px;
  }
}
@media screen and (max-width: 576px){
  .contpre .col-xs-6{
    width: 50%;
  }
  .contpre {
    margin-top: -461px;
  }
  .denuevo{
      margin-top: -277px;
  }
}
@media screen and (max-width: 525px){
  .contbut{
     margin-top: -300px;
  }
  .contpre {
    margin-top: -425px;
  }
  .ajax-loader-container{
    margin-top: 256px !important;
  }
}
@media screen and (max-width: 460px){
    .contbut{
      margin-top: -260px;
  }
  .contpre {
    margin-top: -374px;
  }
  .contpre h4{
    margin-top: 13px;
  }
  .buintentar{
    margin-right: 81px;
    margin-top: 249px;
  }
}
@media screen and (max-width: 410px){
    .contbut{
      margin-top: -236px;
  }
  .contpre h4 {
    margin-top: 48px;
    font-size: 15px;
  }
}
@media screen and (max-width: 370px){
    .contbut{
      margin-top: -224px;
  }
  .contpre h4 {
    margin-top: 69px;
    font-size: 16px;
  }
  .ajax-loader-container {
    margin-top: 207px !important;
  }
  .buintentar {
    margin-right: 42px;
    margin-top: 207px;
  }
}
@media screen and (max-width: 330px){
    .contbut{
      margin-top: -187px;
  }
  .buintentar {
    margin-right: 17px;
    margin-top: 171px;
  }
}

</style>

